<template>
    <div>
        <div v-if="!hideHeader" class="font-normal_medium mb-1">
            {{ discipline?.Name }}
        </div>
        <div class="overflow-x-auto">
            <table class="w-full border border-black/10">
                <thead v-if="!hideTableHeader">
                    <tr>
                        <th class="sticky left-0 w-10 min-w-10">{{ getStrByLng().HEADER_RANK }}</th>
                        <th class="sticky left-0 text-left">{{ getStrByLng().HEADER_ATHLETE }}</th>
                        <th class="w-16 min-w-16 text-center">{{ getStrByLng().HEADER_QUALIFIED }}</th>
                        <th class="w-16 min-w-16 text-right">{{ getStrByLng().HEADER_POINTS }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="athlete in disciplineAthletes" :key="athlete.Id">
                        <td class="sticky left-0 w-10 min-w-10">{{ athlete.Rank }}</td>
                        <td class="sticky left-0 text-left">
                            <div class="flex">
                                <NocFlag class="mr-1" :nat-code="athlete.Nat" />
                                <WdlArchiveName :competitor="athlete"></WdlArchiveName>
                            </div>
                        </td>
                        <td class="w-16 min-w-16 text-center">{{ athlete.Qual ? "Q" : "" }}</td>
                        <td class="w-16 min-w-16 text-right">{{ athlete.Points }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup lang="ts">
import { getStrByLng } from "@swisstiming/webtec-kit";
import { computed } from "vue";

import { IDiamondRaceDiscipline } from "../interfaces/wdl-archive.interfaces";
import NocFlag from "./elements/NocFlag.vue";
import WdlArchiveName from "./elements/WdlArchiveName.vue";

const props = withDefaults(
    defineProps<{
        discipline?: IDiamondRaceDiscipline;
        hideHeader?: boolean;
        top5?: boolean;
        hideTableHeader?: boolean;
    }>(),
    {
        hideHeader: false,
        top5: false,
        hideTableHeader: false
    }
);

const disciplineAthletes = computed(() =>
    props.top5 ? props.discipline?.Athletes?.slice(0, 5) : props.discipline?.Athletes
);
</script>

<style lang="scss"></style>
